'use client';

import React, { useEffect } from 'react';

type SegmentSnippetTemplateProps = {
	snippet: string;
};

type SegmentWindow = Window & {
	analytics?: unknown;
	__rpcSegmentSnippetInjected?: boolean;
};

const templateId = 'segment-snippet-template';
const scriptId = 'segment-snippet';

export default function SegmentSnippetTemplate( {
	snippet,
}: SegmentSnippetTemplateProps ) {
	const encodedSnippet = encodeURIComponent( snippet );

	useEffect( () => {
		const segmentWindow = window as SegmentWindow;

		if (
			document.getElementById( scriptId ) ||
			segmentWindow.analytics ||
			segmentWindow.__rpcSegmentSnippetInjected
		) {
			return;
		}

		const template = document.getElementById( templateId );

		if ( !( template instanceof HTMLElement ) ) {
			return;
		}

		const snippetText = template.dataset.segmentSnippet;

		if ( !snippetText ) {
			return;
		}

		const script = document.createElement( 'script' );
		script.id = scriptId;
		script.text = decodeURIComponent( snippetText );
		segmentWindow.__rpcSegmentSnippetInjected = true;
		document.head.appendChild( script );
	}, [] );

	return (
		<span id={ templateId } hidden data-segment-snippet={ encodedSnippet }></span>
	);
}
